import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import {
  getDisclosureLevel2,
  saveBatchDisclosureLevel2,
} from '../../api/disclosureLevel2';
import type { DisclosureLevel2 } from '../../types/DisclosureLevel2';
import { t } from '../../i18n/t';

const columnDefs: ColDef<DisclosureLevel2>[] = [
  {
    field: 'parentCodeId',
    headerName: t('disclosureLevel2.columns.parentCodeId'),
    width: 140,
    cellDataType: 'text',
    // Add-only like codeId (Nitzan 30/08/2026): re-parenting a saved code is
    // delete + re-add, mirroring the natural-PK rule.
    editable: (params: EditableCallbackParams<DisclosureLevel2>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
  },
  {
    field: 'codeId',
    headerName: t('disclosureLevel2.columns.codeId'),
    width: 140,
    cellDataType: 'text',
    // String natural PK: editable on Add only, read-only after save. The
    // leading zero ('0101'..'9801') must display and round-trip as a string.
    editable: (params: EditableCallbackParams<DisclosureLevel2>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  {
    field: 'codeName',
    headerName: t('disclosureLevel2.columns.codeName'),
    flex: 1,
    editable: true,
  },
];

const newRowDefaults = (): Partial<DisclosureLevel2> => ({
  parentCodeId: '',
  codeId: '',
  codeName: '',
});

export function DisclosureLevel2Page() {
  return (
    <LopCrudPage<DisclosureLevel2>
      resourceCode="disclosureLevel2"
      titleKey="disclosureLevel2.pageTitle"
      idField="codeId"
      getRows={getDisclosureLevel2}
      saveBatch={(added, modified, deletedIds) =>
        saveBatchDisclosureLevel2(added, modified, deletedIds as string[])
      }
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
